/* unplugin-vue-components disabled */import script from "./CustomerTag.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerTag.vue?vue&type=script&setup=true&lang=js"

import "./CustomerTag.vue?vue&type=style&index=0&id=0da52f49&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da52f49"]])

export default __exports__